import React from "react";
import { Bar } from "react-chartjs-2";

const ChartComponent = ({ chartData }) => {
  const chartOptions = {
    scales: {
      x: {
        ticks: {
          font: {
            size: 18  ,
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value.toLocaleString(); // Display y-axis values with comma separators
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Category Breakdown",
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: "400px", width: "100%" }}>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default ChartComponent;
